define([
	'jquery',
	'pubsub',
	'promise!wcs.zmetrics'
	], function( $, pubsub ) {

	if(WCS_CONFIG.get('ANALYTICS::cmEnabled')) {
		
		$.pubsub('subscribe', 'vfdp.wcs.product_form.add_to_cart_succeeded', function(message, data) {
			
			try {
			
				var $productForm = $('.product-form-js').eq(data.productFormIndex);
				var productNameStr = "";
				var unitPriceStr = "0.00";
				var attributeStr = "";
				var $product;
				var parentProductId = $productForm.data('AddToCartForm').productId;
				var childProductId = $productForm.data('AddToCartForm').catEntryId;
				var childPartNumber = $productForm.data('AddToCartForm').productAvailability.getPartNumber(childProductId);
				var bundlePartNumber = $productForm.data("bundle-part-number");

				var seoCategory = $productForm.data("seo-category");
				var isQuickView = $productForm.closest('.quickview-box-js').length === 0 ? false : true;
				var categoryId = (isQuickView ? $(".product-listing-js").data("category-identifier") : '');
				var masterCategoryId = $productForm.data("master-category-identifier");
				var breadcrumb = $productForm.data("breadcrumb");

				if($productForm.parents(".bundle-product-info-js").length > 0){ //bundle
					productNameStr = $productForm.parents(".bundle-product-info-js").find(".product-info-js").text();
					unitPriceStr = $productForm.find(".product-price-amount-js").data("amount");
				}
				else{ //PDP or QuickView
					productNameStr = $("#product-info .product-info-js").text();

					if( $("#product-info .product-price-amount-js").length > 0){
						$product = $("#product-info .product-price-amount-js");
					}
					else if( $("#product-form .product-price-amount-js").length > 0){
						$product = $("#product-form .product-price-amount-js");
					}
					if($product) unitPriceStr = $product.data("amount");
				}

				if($productForm.find(".attr-color-js").length > 0){
					var attributeNameElement = $productForm.find(".attr-color-js .attr-primary-name-js .attr-primary-name-label").clone();
					attributeNameElement.find(".step-number").remove();

					attributeStr += (attributeNameElement.text() + ": " + $productForm.find(".attr-color-js .attr-primary-name-js .attribute-label-value-js").text()).replace(/\t|\n|\r/g,'');
				}
				$productForm.find(".step-container.attribute-value-selected:not(.attr-color)").each(function(){
					var attributeNameElement = $(this).find(".attr-primary-name-js").clone();
					attributeNameElement.find(".step-number").remove();

					var name = attributeNameElement.text().replace(/\t|\n|\r/g,'');
					var value = $(this).find(".attr-input-js[name='attrValue']").val();
					attributeStr += (attributeStr.length > 0 ? " / " : "") + name + ": " + value;
				});
				attributeStr = attributeStr.replace(/[ ]+/g, ' ');

				var parameters = {
					'currency': $("meta[property='og:price:currency']").attr("content"),
					'productName': productNameStr,
					'productId': $productForm.find('input[name="productCode"]').val(),
					'unitPrice': unitPriceStr,
					'definingAttributes': $.trim(attributeStr),
					'quantity': $productForm.find(".quantity-js").val(),
					'categoryId': categoryId ? categoryId : '',
					'masterCategoryId': masterCategoryId ? masterCategoryId : '',
					'childPartNumber': childPartNumber ? childPartNumber : '',
					'parentProductId': parentProductId ? parentProductId : '',
					'childProductId': childProductId ? childProductId : '',
					'bundlePartNumber': bundlePartNumber ? bundlePartNumber : '',
					'seoCategory': seoCategory ? seoCategory : '',
					'isQuickView': isQuickView,
					'isSearch': (isQuickView && categoryId === 'search'),
					'productOrigination': breadcrumb
				};

				zm.trackAddedItem(parameters);
				if (WCS_CONFIG.get('global::bloomReachEnabled') && typeof BrTrk !== "undefined") {
					BrTrk.getTracker().logEvent('cart', 'click-add', {'prod_id': $productForm.find('input[name="productCode"]').val(), 'sku' : (childPartNumber ? childPartNumber : '')});
				}
				
			} catch (err) {
				console.error('Failed push to coremetrics',err);
			}
		});
	}
});